import axios from 'axios';
const http = {
  create(option = {}) {
    const _axios = axios.create(option);
    // 为实例添加请求拦截器
    _axios.interceptors.request.use(
      config => {
        return config;
      },
      error => {
        // 对请求错误做些什么
        return Promise.reject(error);
      }
    );
    return _axios;
  }
};

export default http;
